<template>
  <div>
    <v-progress-linear
      :active="isLoading"
      :indeterminate="isLoading"
      absolute
      top
      color="#743063"
    ></v-progress-linear>
    <br />
    <h3 class="text-center">التبرعات السابقة</h3>
    <v-card max-width="600" class="mx-auto" elevation="0">
      <v-data-table
        :headers="headers"
        :items="orders"
        :items-per-page="5"
        class="ma-2 elevation-1"
        :mobile-breakpoint="0"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="orderDetail(item)">
            mdi-information
          </v-icon>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="showOrderDetailDialog" max-width="500px">
      <v-card>
        <v-app-bar flat color="rgba(0, 0, 0, 0)">
          <v-btn @click="showOrderDetailDialog = false" icon
            ><v-icon color="black">mdi-close</v-icon></v-btn
          >
        </v-app-bar>

        <v-card-title class="text-h5">تفاصيل التبرع</v-card-title>

        <v-card-text>
          <div class="custom-pill mx-auto pa-1 my-1">
            <div class="d-flex justify-space-between px-2">
              <div>رقم العملية</div>
              <div>{{ selectedOrder.id }}</div>
            </div>
          </div>
          <div class="custom-pill mx-auto pa-1 my-1">
            <div class="d-flex justify-space-between px-2">
              <div>المجموع</div>
              <div>{{ selectedOrder.total }}</div>
            </div>
          </div>
          <div class="custom-pill mx-auto pa-1 my-1">
            <div class="d-flex justify-space-between px-2">
              <div>التاريخ و الوقت</div>
              <div>{{ selectedOrder.completedAt }}</div>
            </div>
          </div>
          <div class="custom-pill mx-auto pa-1 my-1">
            <div class="d-flex justify-space-between px-2">
              <div>Payment Id</div>
              <div>{{ selectedOrder.paymentId }}</div>
            </div>
          </div>
          <div class="custom-pill mx-auto pa-1 my-1">
            <div class="d-flex justify-space-between px-2">
              <div>Transaction Id</div>
              <div>{{ selectedOrder.transactionId }}</div>
            </div>
          </div>

          <br />

          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>التبرع</th>
                  <th>المبلغ (دك)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in selectedOrder.lineItems" :key="item.id">
                  <td>{{ item.name.arabic }}</td>
                  <td>{{ item.paidAmount }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        
        <div v-if="selectedOrder.hasDedication" class="pa-2">
          <h4>الاهداء</h4>
          <img :src="selectedOrder.dedicationInfo.dedicationCardUrl" width="100%">
        </div>

        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MyDonations",
  props: {},
  components: {},
  //********************** */
  data: () => ({
    isLoading: false,
    showOrderDetailDialog: false,
    selectedOrder: {
      id: 0,
      total: 0,
      completedAt: "",
      paymentId: "",
      transactionId: "",
      lineItems: [],
    },
    headers: [
      {
        text: "التاريخ",
        align: "start",
        sortable: false,
        value: "completedAt",
      },
      { text: "المبلغ", value: "total" },
      { text: "", value: "actions", sortable: false },
    ],
  }),

  watch: {
    $route: "loadOrders",
  },

  //********************** */
  computed: {
    ...mapGetters("Order", {
      orders: "orders",
    }),
  },

  //********************** */
  methods: {
    loadOrders: async function () {
      this.isLoading = true;

      await this.$store.dispatch("Order/loadCustomerOrders");

      this.isLoading = false;
    },

    orderDetail: function (item) {
      this.selectedOrder = item;
      this.showOrderDetailDialog = true;
    },
  },

  //********************** */
  async created() {
    this.loadOrders();
  },
};
</script>


<style scoped>
.custom-card {
  background: rgb(0, 188, 39);
  background: linear-gradient(
    40deg,
    rgba(0, 188, 39, 1) 24%,
    rgba(0, 161, 32, 1) 76%
  );
  max-width: 300px;
}
.custom-pill {
  border-radius: 25px;
  max-width: 280px;
  border: 1px solid #bbbbba;
  font-size: 14px;
}
</style>